export const taxiTypes = {
  GET_TAXIS: "GET_TAXIS",
  
  SELECT_TAXI_COMPANY: "SELECT_TAXI_COMPANY",
  SELECT_TAXI_STATIONS: "SELECT_TAXI_STATIONS",

  SET_CUSTOMERS_OPT: "SET_CUSTOMERS_OPT",
  SET_CUSTOMER_OPT: "SET_CUSTOMER_OPT",
  SET_CUSTOMER_STATIONS_OPT_SELECTED: "SET_CUSTOMER_STATIONS_OPT_SELECTED",
  SET_CUSTOMER_UNITS_OPT_SELECTED: "SET_CUSTOMER_UNITS_OPT_SELECTED",

  TAXI_REGISTER_NEW: "TAXI_REGISTER_NEW",
  SET_TAXI_CUSTOMER_INFO: "SET_TAXI_CUSTOMER_INFO",
  TAXI_EDIT: "TAXI_EDIT",
  UPDATE_STATIONS_UNITS_TAXI: "UPDATE_STATIONS_UNITS_TAXI",

  SET_CONFIG_PAGE_TAXIS: "SET_CONFIG_PAGE_TAXIS",
  SET_CONFIG_PAGE_TAXIS_COUNT: "SET_CONFIG_PAGE_TAXIS_COUNT",
  SET_CONFIG_SORTED_TAXIS: "SET_CONFIG_SORTED_TAXIS",
  SET_CONFIG_FILTERED_TAXIS: "SET_CONFIG_FILTERED_TAXIS",

  TAXI_RESTORE_MODAL: "TAXI_RESTORE_MODAL"
}